import React from 'react';
import { Link, LinkProps } from '@reach/router';

import { useLinkHasPermission } from './useLinkHasPermission';

export const PermissionedLink: React.FC<
  Omit<
    React.PropsWithoutRef<LinkProps<any>> & React.RefAttributes<HTMLAnchorElement>,
    'onClick' | 'onHover'
  > & {
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => boolean | void;
    skipDirtyForm?: boolean;
    disabled?: boolean;
  }
> = ({ children, to, onClick, disabled, skipDirtyForm, ...props }) => {
  // link ref
  const { linkHasPermission, linkRef } = useLinkHasPermission();

  // get form id that is dirty
  return (
    <>
      <Link
        to={to}
        className={`${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} ${props.className}`}
        {...props}
        ref={linkRef}
        onClick={(e: React.MouseEvent<HTMLAnchorElement>): boolean => {
          if (!linkHasPermission(to, { disabled, skipDirtyForm })) {
            e.preventDefault();
            return false;
          }

          if (onClick) {
            return onClick(e);
          }

          return true;
        }}
      >
        {children}
      </Link>
    </>
  );
};

export default PermissionedLink;
